
import { useState, useEffect } from 'react';

const RechlichesPage = () => {
  const [activeSection, setActiveSection] = useState('faq');

  const sections = [
    { id: 'faq', title: 'FAQ', icon: 'ri-question-line' },
    { id: 'versand', title: 'Versand & Zahlung', icon: 'ri-truck-line' },
    { id: 'impressum', title: 'Impressum', icon: 'ri-building-line' },
    { id: 'datenschutz', title: 'Datenschutz', icon: 'ri-shield-line' },
    { id: 'agb', title: 'AGB', icon: 'ri-file-text-line' },
    { id: 'widerruf', title: 'Widerrufsrecht', icon: 'ri-arrow-go-back-line' }
  ];

  useEffect(() => {
    // Scroll to section if hash is present
    const hash = window.location.hash.replace('#', '');
    if (hash && sections.includes(hash)) {
      setActiveSection(hash);
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const faqItems = [
    {
      question: "Wer kann bei Dä Snäckomat bestellen?",
      answer: "Nur Personen mit einem gültigen Zugangscode können Bestellungen aufgeben. Dieser wird von uns nach Prüfung der Berechtigung vergeben. Kontaktieren Sie uns unter info@snaeckomat.ch für weitere Informationen."
    },
    {
      question: "Wie funktioniert der Bestellvorgang?",
      answer: "Nach Ihrer Bestellanfrage erhalten Sie eine Rechnung von uns. Erst nach Zahlungseingang (per TWINT oder Banküberweisung) wird Ihre Bestellung bearbeitet und versendet. Die Lieferzeit beträgt 3-7 Werktage nach Zahlungseingang."
    },
    {
      question: "Ist meine Bestellung verbindlich?",
      answer: "Ja, für Sie als Kunde ist die Bestellanfrage verbindlich. Für uns als Unternehmen ist sie jedoch nicht verbindlich, da wir uns vorbehalten müssen, Bestellungen bei Nichtverfügbarkeit oder anderen Gründen abzulehnen."
    },
    {
      question: "Können sich die Preise ändern?",
      answer: "Ja, wir behalten uns das Recht vor, Preise jederzeit zu ändern. Die zum Zeitpunkt Ihrer Bestellung gültigen Preise sind maßgeblich. Bei größeren Preisänderungen informieren wir Sie vor der Rechnungsstellung."
    },
    {
      question: "Welche Zahlungsmethoden akzeptieren Sie?",
      answer: "Wir akzeptieren TWINT und Banküberweisung. Die Zahlung muss vor dem Versand erfolgen. Barzahlung oder Zahlung bei Lieferung ist nicht möglich."
    },
    {
      question: "Kann ich meine Bestellung stornieren?",
      answer: "Eine Stornierung ist nur vor dem Versand möglich. Nach dem Versand können Lebensmittel aus hygienischen Gründen nicht zurückgenommen werden, außer bei beschädigter oder falscher Ware."
    }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'faq':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Häufig gestellte Fragen (FAQ)</h2>
              <p className="text-gray-600 mb-8">Hier finden Sie Antworten auf die wichtigsten Fragen zu unserem Snack-Shop.</p>
            </div>
            <div className="space-y-4">
              {faqItems.map((item, index) => (
                <FAQItem key={index} question={item.question} answer={item.answer} />
              ))}
            </div>
          </div>
        );

      case 'versand':
        return (
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Versand &amp; Zahlung</h2>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-information-line text-blue-600 mr-2"></i>
                Wichtiger Hinweis zum Bestellvorgang
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nur Personen mit gültigem Zugangscode können Bestellungen aufgeben. Nach Ihrer Bestellanfrage erhalten Sie eine Rechnung. 
                <strong> Die Bestellung wird erst nach Zahlungseingang (TWINT, Bargeld oder Banküberweisung) ausgelöst und bearbeitet.</strong>
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Versand:</strong> Abholung oder Versand nach Absprache möglich.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Zahlungsbedingungen</h3>
              <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Zahlungsmethoden</h4>
                    <p className="text-gray-600">TWINT, Bargeld oder Banküberweisung</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Zahlungszeitpunkt</h4>
                    <p className="text-gray-600">Bestellung wird erst nach Zahlungseingang ausgelöst</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Verbindlichkeit</h4>
                    <p className="text-gray-600">Bestellanfrage ist für Kunden verbindlich, für uns nicht verbindlich</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Preisänderungen</h4>
                    <p className="text-gray-600">Wir behalten uns das Recht vor, Preise jederzeit zu ändern</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-alert-line text-orange-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Produktverfügbarkeit</h4>
                    <p className="text-gray-600">Produkte können ausverkauft sein. Nicht verfügbare Artikel werden nicht verrechnet.</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">Versandinformationen</h3>
              <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-truck-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Lieferzeit</h4>
                    <p className="text-gray-600">3-7 Werktage nach Zahlungseingang</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-store-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Versandart</h4>
                    <p className="text-gray-600">Abholung oder Versand nach Absprache</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-blue-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Versandgebiet</h4>
                    <p className="text-gray-600">Schweiz</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-red-600 text-xl mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-800">Rückgabe</h4>
                    <p className="text-gray-600">Lebensmittel können aus hygienischen Gründen nicht zurückgenommen werden, außer bei beschädigter oder falscher Ware</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'impressum':
        return (
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Impressum</h2>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Angaben gemäß Schweizer Recht</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-gray-800">Firmenname</h4>
                  <p className="text-gray-600">Dä Snäckomat</p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Kontakt</h4>
                  <p className="text-gray-600">
                    Telefon: +41 76 629 09 01<br />
                    E-Mail: info@snaeckomat.ch<br />
                    Website: https://snaeckomat.ch
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Geschäftstätigkeit</h4>
                  <p className="text-gray-600">
                    Snack- und Getränkeautomaten, Verkauf von Snacks und Getränken
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Haftungsausschluss</h3>
              <div className="space-y-4 text-gray-700">
                <p>
                  <strong>Haftung für Inhalte:</strong> Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. 
                  Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
                <p>
                  <strong>Haftung für Links:</strong> Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                  Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                </p>
                <p>
                  <strong>Urheberrecht:</strong> Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem schweizerischen Urheberrecht. 
                  Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </div>
        );

      case 'datenschutz':
        return (
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Datenschutzerklärung</h2>
              <p className="text-gray-600">
                Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten auf.
              </p>
            </div>

            <div className="space-y-6">
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">1. Verantwortliche Stelle</h3>
                <p className="text-gray-700">
                  Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
                  <strong>Dä Snäckomat</strong><br />
                  E-Mail: info@snaeckomat.ch<br />
                  Telefon: +41 76 629 09 01
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Erhebung und Speicherung personenbezogener Daten</h3>
                <div className="space-y-3 text-gray-700">
                  <p><strong>Bei Bestellungen erheben wir:</strong></p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Name und Vorname</li>
                    <li>Lieferadresse</li>
                    <li>E-Mail-Adresse</li>
                    <li>Telefonnummer</li>
                    <li>Bestelldaten und Zahlungsinformationen</li>
                  </ul>
                  <p className="mt-4">
                    <strong>Rechtsgrundlage:</strong> Die Verarbeitung erfolgt zur Erfüllung des Vertrages (Art. 6 Abs. 1 lit. b DSGVO).
                  </p>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">3. Zweck der Datenverarbeitung</h3>
                <div className="space-y-2 text-gray-700">
                  <p>Ihre Daten verwenden wir ausschließlich für:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Bearbeitung und Abwicklung Ihrer Bestellungen</li>
                    <li>Kommunikation bezüglich Ihrer Bestellung</li>
                    <li>Rechnungsstellung und Zahlungsabwicklung</li>
                    <li>Erfüllung gesetzlicher Aufbewahrungspflichten</li>
                  </ul>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Speicherdauer</h3>
                <p className="text-gray-700">
                  Ihre personenbezogenen Daten werden für die Dauer der Geschäftsbeziehung und darüber hinaus 
                  entsprechend den gesetzlichen Aufbewahrungsfristen (in der Regel 10 Jahre) gespeichert.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">5. Ihre Rechte</h3>
                <div className="space-y-2 text-gray-700">
                  <p>Sie haben das Recht auf:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>Auskunft über Ihre gespeicherten Daten</li>
                    <li>Berichtigung unrichtiger Daten</li>
                    <li>Löschung Ihrer Daten</li>
                    <li>Einschränkung der Verarbeitung</li>
                    <li>Datenübertragbarkeit</li>
                    <li>Widerspruch gegen die Verarbeitung</li>
                  </ul>
                  <p className="mt-4">
                    Zur Ausübung Ihrer Rechte kontaktieren Sie uns unter: info@snaeckomat.ch
                  </p>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">6. Datensicherheit</h3>
                <p className="text-gray-700">
                  Wir verwenden geeignete technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten gegen 
                  zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen.
                </p>
              </div>
            </div>
          </div>
        );

      case 'agb':
        return (
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Allgemeine Geschäftsbedingungen (AGB)</h2>
              <p className="text-gray-600">
                Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen über unseren Snack-Shop.
              </p>
            </div>

            <div className="space-y-6">
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 1 Geltungsbereich</h3>
                <p className="text-gray-700">
                  Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen Dä Snäckomat und dem Kunden. 
                  Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, wir haben ausdrücklich schriftlich zugestimmt.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 2 Zugangsberechtigung</h3>
                <p className="text-gray-700">
                  Bestellungen können nur von Personen mit gültigem Zugangscode aufgegeben werden. 
                  Der Zugangscode wird nach Prüfung der Berechtigung vergeben und ist nicht übertragbar.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 3 Vertragsschluss und Verbindlichkeit</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    Die Bestellanfrage des Kunden stellt ein verbindliches Angebot dar. 
                    Der Vertrag kommt durch unsere Annahme (Rechnungsstellung) zustande.
                  </p>
                  <p>
                    <strong>Wichtig:</strong> Für uns als Unternehmen ist die Bestellanfrage nicht verbindlich, 
                    da wir uns vorbehalten müssen, Bestellungen bei Nichtverfügbarkeit oder anderen Gründen abzulehnen.
                  </p>
                  <p>
                    <strong>Produktverfügbarkeit:</strong> Einzelne Produkte können ausverkauft sein. 
                    In diesem Fall werden die nicht verfügbaren Artikel nicht verrechnet und die Rechnung entsprechend angepasst.
                  </p>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 4 Preise und Preisänderungen</h3>
                <p className="text-gray-700">
                  Alle Preise verstehen sich in Schweizer Franken (CHF) inklusive der gesetzlichen Mehrwertsteuer. 
                  Wir behalten uns das Recht vor, Preise jederzeit zu ändern. 
                  Maßgeblich sind die zum Zeitpunkt der Bestellung gültigen Preise.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 5 Zahlung und Versand</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    Die Zahlung erfolgt per TWINT, Bargeld oder Banküberweisung. 
                    <strong> Die Bestellung wird erst nach vollständigem Zahlungseingang ausgelöst und bearbeitet.</strong>
                  </p>
                  <p>
                    <strong>Versand:</strong> Abholung oder Versand nach Absprache möglich. 
                    Die Lieferzeit beträgt 3-7 Werktage nach Zahlungseingang.
                  </p>
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 6 Lieferung und Gefahrübergang</h3>
                <p className="text-gray-700">
                  Die Lieferung erfolgt an die vom Kunden angegebene Adresse. 
                  Mit der Übergabe an den Versanddienstleister geht die Gefahr auf den Kunden über.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 7 Gewährleistung</h3>
                <p className="text-gray-700">
                  Es gelten die gesetzlichen Gewährleistungsbestimmungen. 
                  Bei beschädigter oder falscher Ware kontaktieren Sie uns innerhalb von 7 Tagen nach Erhalt.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 8 Haftung</h3>
                <p className="text-gray-700">
                  Unsere Haftung ist auf Vorsatz und grobe Fahrlässigkeit beschränkt. 
                  Die Haftung für mittelbare Schäden und entgangenen Gewinn ist ausgeschlossen.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 9 Datenschutz</h3>
                <p className="text-gray-700">
                  Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung.
                </p>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">§ 10 Schlussbestimmungen</h3>
                <div className="space-y-3 text-gray-700">
                  <p>
                    Es gilt schweizerisches Recht unter Ausschluss des UN-Kaufrechts.
                  </p>
                  <p>
                    Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'widerruf':
        return (
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Widerrufsrecht</h2>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-alert-line text-red-600 mr-2"></i>
                Wichtiger Hinweis zu Lebensmitteln
              </h3>
              <p className="text-gray-700 leading-relaxed">
                <strong>Lebensmittel können aus hygienischen Gründen grundsätzlich nicht zurückgenommen werden.</strong> 
                Dies gilt für alle Snacks, Getränke und andere Lebensmittel in unserem Sortiment.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Ausnahmen vom Widerrufsrecht</h3>
              <div className="space-y-4 text-gray-700">
                <p>
                  Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind 
                  und für deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist 
                  oder die eindeutig auf die persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind.
                </p>
                <p>
                  <strong>Insbesondere ausgeschlossen ist das Widerrufsrecht bei:</strong>
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Lebensmitteln und Getränken</li>
                  <li>Waren, die schnell verderben können</li>
                  <li>Waren, die aus hygienischen Gründen nicht zur Rückgabe geeignet sind</li>
                </ul>
              </div>
            </div>

            <div className="bg-green-50 border border-green-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-check-line text-green-600 mr-2"></i>
                Reklamation bei Mängeln
              </h3>
              <div className="space-y-3 text-gray-700">
                <p>
                  <strong>Bei beschädigter oder falscher Ware</strong> kontaktieren Sie uns bitte innerhalb von 7 Tagen nach Erhalt:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>E-Mail: info@snaeckomat.ch</li>
                  <li>Telefon: +41 76 629 09 01</li>
                </ul>
                <p>
                  Wir werden den Mangel prüfen und eine angemessene Lösung finden (Ersatzlieferung oder Erstattung).
                </p>
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                <i className="ri-information-line text-blue-600 mr-2"></i>
                Stornierung vor Versand
              </h3>
              <p className="text-gray-700">
                Eine Stornierung Ihrer Bestellung ist nur vor dem Versand möglich. 
                Kontaktieren Sie uns umgehend, falls Sie Ihre Bestellung stornieren möchten.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Muster-Widerrufsformular</h3>
              <div className="bg-gray-50 p-4 rounded border text-sm text-gray-700">
                <p className="mb-4">
                  <strong>An:</strong><br />
                  Dä Snäckomat<br />
                  E-Mail: info@snaeckomat.ch
                </p>
                <p className="mb-4">
                  Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*):
                </p>
                <p className="mb-4">
                  Bestellt am (*) / erhalten am (*): _______________<br />
                  Name des/der Verbraucher(s): _______________<br />
                  Anschrift des/der Verbraucher(s): _______________<br />
                  Datum: _______________
                </p>
                <p className="text-xs">
                  (*) Unzutreffendes streichen
                </p>
              </div>
              <p className="text-sm text-gray-600 mt-4">
                <strong>Hinweis:</strong> Dieses Formular ist nur bei widerrufsfähigen Waren anwendbar. 
                Lebensmittel sind grundsätzlich vom Widerrufsrecht ausgeschlossen.
              </p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Rechtliche Informationen</h1>
              <p className="text-gray-600 mt-2">Alle wichtigen rechtlichen Bestimmungen für unseren Snack-Shop</p>
            </div>
            <button 
              onClick={() => window.history.back()}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Zurück zum Shop</span>
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm border sticky top-8">
              <div className="p-6">
                <h2 className="text-lg font-semibold text-gray-800 mb-4">Navigation</h2>
                <nav className="space-y-2">
                  {sections.map((section) => (
                    <button
                      key={section.id}
                      onClick={() => setActiveSection(section.id)}
                      className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors ${
                        activeSection === section.id
                          ? 'bg-blue-50 text-blue-700 border border-blue-200'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800'
                      }`}
                    >
                      <i className={`${section.icon} text-lg`}></i>
                      <span className="font-medium">{section.title}</span>
                    </button>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-lg shadow-sm border">
              <div className="p-8">
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FAQItem = ({ question, answer }: { question: string; answer: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white border border-gray-200 rounded-lg">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <h3 className="text-lg font-semibold text-gray-800 pr-4">{question}</h3>
        <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line text-gray-500 text-xl flex-shrink-0`}></i>
      </button>
      {isOpen && (
        <div className="px-6 pb-4">
          <div className="border-t border-gray-100 pt-4">
            <p className="text-gray-700 leading-relaxed">{answer}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RechlichesPage;
